"use strict";

import React from 'react';
import Icons from "./Icon";

const DocumentDesignProofLink = ({title='', className='', style={}, documentId='', username=''}) => {
    const baseUrl = 'https://pf801100-orderprocess-sys.com/tenenz';

    function onClick(e, href){
        e.preventDefault();
        const windowName = 'pdfPreview',
            windowParams = 'height=300,width=300',
            windowObj = window.open(href,windowName,windowParams);
        windowObj.focus();
    }
    const href = `${baseUrl}/PMGetPdfProof.aspx?DocID=${encodeURIComponent(documentId)}&UserName=${encodeURIComponent(username)}`;

    if(documentId){
        return (
            <a href={href} title={title} className={className} style={style} onClick={(e)=>{onClick(e, href);}} >
                <Icons name="pdf" className="icon--collapse-right" />
            </a>
        );
    }
    return null;
};

export default DocumentDesignProofLink;